(() => {
  const initialize = () => document.querySelectorAll('product-form[data-tj-total]').forEach(form => {
    if (form.tjTotalInitialized) return;
    form.tjTotalInitialized = true;
    const info = form.closest('product-info');
    const button = form.querySelector('[name="add"]');
    const label = button.querySelector('span');
    let price = Number(form.dataset.tjPrice);
    const formatMoney = (cents) => {
      const formats = {
        amount: [2, ',', '.'], amount_no_decimals: [0, ',', '.'],
        amount_with_comma_separator: [2, '.', ','], amount_no_decimals_with_comma_separator: [0, '.', ','],
        amount_with_apostrophe_separator: [2, "'", '.'], amount_with_space_separator: [2, ' ', ','],
        amount_no_decimals_with_space_separator: [0, ' ', '.'], amount_with_period_and_space_separator: [2, ' ', '.']
      };
      const template = form.dataset.tjMoneyFormat;
      const token = template.match(/\{\{\s*(\w+)\s*\}\}/);
      if (!token || !formats[token[1]]) return new Intl.NumberFormat(form.dataset.tjLocale, { style: 'currency', currency: form.dataset.tjCurrency }).format(cents / 100);
      const [precision, thousands, decimal] = formats[token[1]];
      const parts = (cents / 100).toFixed(precision).split('.');
      const amount = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (parts[1] ? decimal + parts[1] : '');
      const element = document.createElement('div');
      element.innerHTML = template.replace(token[0], amount);
      return element.textContent;
    };
    const update = () => {
      if (button.disabled || button.classList.contains('loading') || button.getAttribute('aria-disabled') === 'true') return;
      const quantity = Number(info.querySelector('[name="quantity"]')?.value || 1);
      const money = formatMoney(price * quantity);
      const next = form.dataset.tjLabel.replace('[price]', money);
      if (label.textContent !== next) label.textContent = next;
    };
    info.addEventListener('input', update);
    info.addEventListener('change', update);
    const observer = new MutationObserver(update);
    observer.observe(button, { attributes: true, childList: true, subtree: true });
    const unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
      if (event.data.sectionId !== form.dataset.sectionId) return;
      if (!event.data.variant) return;
      price = event.data.variant.price;
      update();
    });
    const removal = new MutationObserver(() => {
      if (form.isConnected) return;
      observer.disconnect(); removal.disconnect(); unsubscribe();
    });
    removal.observe(document.body, { childList: true, subtree: true });
    update();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  document.addEventListener('shopify:section:load', initialize);
  new MutationObserver(initialize).observe(document.body, { childList: true, subtree: true });
})();
